// Qimora PDP reviews (section qm-review-list): topic and star filters, sorting, Show more, Read more.
// All reviews are already in the page; this only reorders and hides cards. No requests, no third party.
const STEP = 10;
// German /de (1 Nov 2026): the count words come from window.QM_I18N (snippets/qm-i18n.liquid); English is the fallback.
const qmT = (key, fallback, vars) => {
  const all = window.QM_I18N || {};
  let s = typeof all[key] === 'string' && all[key] ? all[key] : fallback;
  if (vars) s = s.replace(/\{(\w+)\}/g, (m, k) => (k in vars ? String(vars[k]) : m));
  return s;
};

document.querySelectorAll('[data-rv]').forEach((root) => {
  const list = root.querySelector('[data-rv-list]');
  if (!list) return;
  const cards = Array.from(list.children);
  const more = root.querySelector('[data-rv-showmore]');
  const empty = root.querySelector('[data-rv-empty]');
  const count = root.querySelector('[data-rv-count]');
  const sort = root.querySelector('[data-rv-sort]');
  const initial = parseInt(root.dataset.rvInitial, 10) || 3;
  const state = { topic: '', stars: 0, sort: 'recent', limit: initial };

  const byDate = (a, b) => b.dataset.date - a.dataset.date;
  const sorters = {
    recent: byDate,
    high: (a, b) => b.dataset.stars - a.dataset.stars || byDate(a, b),
    low: (a, b) => a.dataset.stars - b.dataset.stars || byDate(a, b),
  };

  function checkClamp() {
    // "Read more" only where the text is actually cut (phones clamp at four lines).
    cards.forEach((card) => {
      if (card.hidden || card.classList.contains('is-open')) return;
      const text = card.querySelector('.rv-text');
      const btn = card.querySelector('[data-rv-more]');
      if (text && btn) btn.hidden = text.scrollHeight <= text.clientHeight + 2;
    });
  }

  function apply() {
    const ordered = cards.slice().sort(sorters[state.sort] || byDate);
    let matching = 0;
    ordered.forEach((card) => {
      list.appendChild(card);
      const topicOk = !state.topic || (' ' + card.dataset.topics + ' ').includes(' ' + state.topic + ' ');
      const starsOk = !state.stars || Number(card.dataset.stars) === state.stars;
      if (topicOk && starsOk) {
        matching += 1;
        card.hidden = matching > state.limit;
      } else {
        card.hidden = true;
      }
    });
    if (more) more.hidden = matching <= state.limit;
    if (empty) empty.hidden = matching > 0;
    if (count) count.textContent = matching === 1 ? qmT('common.review_count_one', '{n} review', { n: matching }) : qmT('common.review_count_other', '{n} reviews', { n: matching });
    checkClamp();
  }

  root.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-rv-topic]');
    const bar = event.target.closest('[data-rv-stars]');
    const readMore = event.target.closest('[data-rv-more]');
    if (chip) {
      state.topic = chip.dataset.rvTopic;
      root.querySelectorAll('[data-rv-topic]').forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
      state.limit = initial;
      apply();
    } else if (bar) {
      const stars = Number(bar.dataset.rvStars);
      state.stars = state.stars === stars ? 0 : stars;
      root.querySelectorAll('[data-rv-stars]').forEach((b) => b.setAttribute('aria-pressed', Number(b.dataset.rvStars) === state.stars ? 'true' : 'false'));
      state.limit = initial;
      apply();
    } else if (readMore) {
      readMore.closest('.rv-card').classList.add('is-open');
      readMore.hidden = true;
    } else if (more && event.target.closest('[data-rv-showmore]')) {
      state.limit += STEP;
      apply();
    }
  });

  if (sort) sort.addEventListener('change', () => { state.sort = sort.value; apply(); });

  list.classList.add('is-ready');
  apply();
  window.addEventListener('resize', checkClamp, { passive: true });
});
